import { render, staticRenderFns } from "./ConfigVocalPhoneNumber.vue?vue&type=template&id=c286c8fe&scoped=true&"
import script from "./ConfigVocalPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./ConfigVocalPhoneNumber.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigVocalPhoneNumber.vue?vue&type=style&index=0&id=c286c8fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c286c8fe",
  null
  
)

export default component.exports